/* ============================
 * MODAL DE TÉRMINOS — NOCHE DE DESPECHO
 * ============================ */
function openNocheTermsModal() {
  var overlay = document.getElementById("termsModalOverlay");
  if (!overlay) return;
  overlay.style.display = "flex";
  document.body.style.overflow = "hidden";
  // Reset scroll
  var body = document.getElementById("termsModalBody");
  if (body) body.scrollTop = 0;
  updateTermsProgress();
}

function closeNocheTermsModal() {
  var overlay = document.getElementById("termsModalOverlay");
  if (!overlay) return;
  overlay.style.display = "none";
  document.body.style.overflow = "";
}

function updateTermsProgress() {
  var body = document.getElementById("termsModalBody");
  var bar = document.getElementById("termsProgressBar");
  var hint = document.getElementById("termsScrollHint");
  var acceptBtn = document.getElementById("termsAcceptBtn");
  var acceptText = document.getElementById("termsAcceptText");
  if (!body || !bar) return;

  var scrollTop = body.scrollTop;
  var scrollHeight = body.scrollHeight - body.clientHeight;
  var progress = scrollHeight > 0 ? (scrollTop / scrollHeight) * 100 : 100;
  bar.style.width = progress + "%";

  // Activar botón cuando llega al final (tolerancia de 50px)
  if (scrollTop + body.clientHeight >= body.scrollHeight - 50) {
    acceptBtn.disabled = false;
    acceptBtn.querySelector("i").className = "fas fa-check-circle";
    acceptText.textContent = "Acepto los Términos y Condiciones";
    if (hint) hint.style.display = "none";
  }
}

document.addEventListener("DOMContentLoaded", function () {
  /* --- Modal event listeners --- */
  var modalBody = document.getElementById("termsModalBody");
  var overlay = document.getElementById("termsModalOverlay");
  var closeBtn = document.getElementById("termsModalClose");
  var declineBtn = document.getElementById("termsDeclineBtn");
  var acceptBtn = document.getElementById("termsAcceptBtn");

  if (modalBody) {
    modalBody.addEventListener("scroll", updateTermsProgress);
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", closeNocheTermsModal);
  }

  if (declineBtn) {
    declineBtn.addEventListener("click", closeNocheTermsModal);
  }

  if (overlay) {
    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closeNocheTermsModal();
    });
  }

  if (acceptBtn) {
    acceptBtn.addEventListener("click", function () {
      if (this.disabled) return;
      var checkbox = document.getElementById("agree_terms");
      if (checkbox) checkbox.checked = true;

      // Registrar aceptación como atributo de la orden
      var attrInput = document.getElementById("terms_acceptance_attr");
      if (attrInput) {
        var now = new Date();
        var formatted = now.toLocaleDateString("es-MX") + " a las " + now.toLocaleTimeString("es-MX");
        attrInput.value = "Aceptado el " + formatted;
      }

      closeNocheTermsModal();
    });
  }

  // Cerrar modal con Escape
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeNocheTermsModal();
  });

  /* --- Checkbox change handler --- */
  var termsCheckbox = document.getElementById("agree_terms");
  var termsContainer = document.querySelector(
    ".cart-optimized__terms-checkbox",
  );

  if (termsCheckbox) {
    termsCheckbox.addEventListener("change", function () {
      // Si es producto Noche de Despecho, no permitir check manual sin modal
      var isEvent =
        termsContainer &&
        termsContainer.classList.contains(
          "cart-optimized__terms-checkbox--event",
        );
      if (isEvent && this.checked) {
        this.checked = false;
        openNocheTermsModal();
        return;
      }
      if (this.checked && termsContainer) {
        termsContainer.style.borderColor = "#e0e0e0";
        termsContainer.style.backgroundColor = "#f8f9fa";
      }
    });
  }
});

/* ============================
 * VALIDACIÓN AL ENVIAR FORMULARIO
 * ============================ */
function validateTermsCheckbox() {
  var termsCheckbox = document.getElementById("agree_terms");
  var termsContainer = document.querySelector(
    ".cart-optimized__terms-checkbox",
  );
  var isNocheDespecho = document.getElementById("termsModalOverlay") !== null;

  if (!termsCheckbox.checked) {
    if (isNocheDespecho) {
      // Abrir modal en lugar de alert
      openNocheTermsModal();
    } else {
      // Comportamiento original para otros productos
      if (termsContainer) {
        termsContainer.style.borderColor = "#dc3545";
        termsContainer.style.backgroundColor = "rgba(220, 53, 69, 0.1)";
      }
      alert(
        "Por favor, acepta los Términos y Condiciones para continuar con tu compra.",
      );
      termsCheckbox.focus();
      setTimeout(function () {
        if (termsContainer) {
          termsContainer.style.borderColor = "#e0e0e0";
          termsContainer.style.backgroundColor = "#f8f9fa";
        }
      }, 3000);
    }
    return false;
  }
  return true;
}